export class PlannerAccountMeta {
  //
}
